import { Component, Input } from '@angular/core';
import { AutopayPromoDetails } from '../autopay-promo.model';
import { IconComponent } from '@rogers/cdk/icon';
import { DatePipe } from '@angular/common';
import { FormatPhonePipe } from '@rogers/self-serve-utils/format-phone';
import { FormatDiscountPipe } from '@rogers/self-serve-utils/format-discount';
import { TranslatePipe } from '@ngx-translate/core';

@Component({
  selector: 'fss-autopay-promo-details-body',
  templateUrl: './autopay-promo-details-body.component.html',
  imports: [IconComponent, DatePipe, FormatPhonePipe, FormatDiscountPipe, TranslatePipe],
})
export class AutopayPromoDetailsBodyComponent {
  @Input() language: string;
  @Input() autopayPromotionDetails: AutopayPromoDetails;
  @Input() dateFormat: string;
  @Input() totalAutopayPromotions: number;
}
